
import axios from "axios";
import PhotoSwipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm';

import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { CircularProgress } from "@material-ui/core";

import UploadButton from 'form/UploadButton';
import { ListContext, ListProvider } from 'core/ListProvider';
import UploadedDocumentItem from './UploadedDocumentItem';


const StyledOrderUploadDocumentGroup = styled.div`
  h3 {
    margin: 0;
    padding: 0;
    cursor: pointer;
    font-size: 14px;
    
    display: flex;
    align-items: center;
  }
`;


export default function OrderUploadDocumentGroup({group, order, isOpen}) {
  const [open, setOpen] = useState(isOpen);
  const [total, setTotal] = useState(null);
  const [gallery, setGallery] = useState(null);

  const setPreviewItems = (state) => {
    let dataSource = [];
    state.items.forEach(item => {
      if (item.is_image) {
        dataSource.push({
          downloadUrl: item.file,
          src: item.file,
          caption: item.file_name,
          alt: item.file_name,
          w: item.image_size?.width,
          h: item.image_size?.height
        })
      } else if (item.file_content_type === 'application/pdf') {
        dataSource.push({
          downloadUrl: item.file,
          caption: item.file_name,
          html:
            `<div class="pswp__custom-pdf-slide">` +
            `<embed src="${item.file}" type="application/pdf" width="100%" height="100%" />` +
            `</div>`
        })
      }
      else {
        dataSource.push({
          downloadUrl: item.file,
          caption: item.file_name,
          html:
            `<div class="pswp__custom-no-preview">Предпросмотр не поддерживается</div>`
        })
      }
    })
    let psGallery = new PhotoSwipeLightbox({
      pswpModule: PhotoSwipe,
      dataSource: dataSource,
      showHideAnimationType: 'none'
    });
    psGallery.on('uiRegister', function() {
      psGallery.pswp.ui.registerElement({
        name: 'custom-caption',
        order: 9,
        isButton: false,
        appendTo: 'root',
        html: 'Caption text',
        onInit: (el, pswp) => {
          psGallery.pswp.on('change', () => {
            el.innerHTML = pswp.currSlide.data.caption;
          });
        }
      });
    });
    psGallery.on('uiRegister', function () {
      psGallery.pswp.ui.registerElement({
        name: 'download-button',
        order: 8,
        isButton: true,
        tagName: 'a',
        html: {
          isCustomSVG: true,
          inner: '<path d="M20.5 14.3 17.1 18V10h-2.2v7.9l-3.4-3.6L10 16l6 6.1 6-6.1ZM23 23H9v2h14Z" id="pswp__icn-download"/>',
          outlineID: 'pswp__icn-download'
        },

        onInit: (el, pswp) => {
          el.setAttribute('download', '');
          el.setAttribute('target', '_blank');
          el.setAttribute('rel', 'noopener');

          pswp.on('change', () => {
            el.href = pswp.currSlide.data.downloadUrl;
          });
        }
      });
    });
    psGallery.init();
    setGallery(psGallery);
  }

  const showPreview = (e, index) => {
    e.preventDefault();
    gallery.loadAndOpen(index);
  }

  useEffect(() => {
    axios.get(`order/uploaded-document/count`, {params: {
      orders: order.id,
      group: group.id
    }}).then(res => {
      setTotal(res.data.count)
    })
  }, []);

  return (
    <StyledOrderUploadDocumentGroup>
      <h3 onClick={() => setOpen(!open)}>
        {group.name} ({total === null ? '...' : total})
        <span className={'ml-10'}>{open ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}</span>
      </h3>

      {open && (
        <div className={'mt-5'}>
          <ListProvider
            url={`order/uploaded-document`}
            filterDefaults={{
              orders: order.id,
              group: group.id
            }}
            onComplete={(context, state) => setPreviewItems(state)}
          >
            <ListContext.Consumer>
              {context => {
                const { loading, items } = context;
                return (
                  <React.Fragment>
                    <UploadButton
                      url={'order/uploaded-document'}
                      data={{
                        order: order.id,
                        group: group.id
                      }}
                      onUploaded={(data) => context.reload()}
                    />

                    {loading && (
                      <div className={'mt-20'}>
                        <CircularProgress size={20} />
                      </div>
                    )}

                    {items.length > 0 && (
                      <div className={'mt-20'}>
                        {items.map((item, index) =>
                          <UploadedDocumentItem
                            key={item.id}
                            item={item}
                            context={context}
                            order={order}
                            onClick={(e) => showPreview(e, index)}
                          />
                        )}
                      </div>
                    )}
                  </React.Fragment>
                )
              }}
            </ListContext.Consumer>
          </ListProvider>
        </div>
      )}
    </StyledOrderUploadDocumentGroup>
  )
}
